import { IsEmail, IsNotEmpty, IsArray, IsOptional } from "class-validator";

import { ISubscription } from "./subscription.interface";

export class SubscriptionDto implements Omit<ISubscription, "_id"> {
  
  @IsNotEmpty()
  first_name: string;

  @IsNotEmpty()
  last_name: string;

  @IsEmail()
  email: string;

  @IsNotEmpty()
  phone: string;

  @IsNotEmpty()
  club_name: string;

  @IsNotEmpty()
  events_per_year: string;

  @IsArray()
  event_types: string[];

  @IsArray()
  sanctioned_event_types: string[];
}
